import React from "react";
import { Button, Box, Flex, Text, Heading } from "@chakra-ui/react";
import { ReactComponent as CoachingCallCTAImage } from "assets/coaching-call-cta.svg";
import { useUser } from "context/user";

const SidebarCTA: React.FC = () => {
  const { user } = useUser()!;
  return (
    <Flex direction="column" align="center" my={6}>
      <Box w="200px" mb="-25px" zIndex={1200}>
        <CoachingCallCTAImage width="100%" />
      </Box>
      <Flex
        zIndex={1100}
        direction="column"
        alignItems="center"
        justifyContent="center"
        bg="blue.700"
        color="white"
        borderRadius="xl"
        fontWeight="400"
        fontSize="md"
        p={6}
        pt={10}
        width="220px"
        textAlign="center"
      >
        <Heading as="h3" fontSize="xl" fontWeight="600">
          Coaching Call
        </Heading>
        <Text my={4}>Schedule a call with your coach now.</Text>
        {!!user?.coach?.email && (
          <Button
            as="a"
            href={`mailto:${user.coach.email}`}
            variant="blue"
            size="md"
          >
            Schedule
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default SidebarCTA;
